import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { firebase_config } from "./lib/configs";

// Firebase configuration
const firebaseConfig = {
  apiKey: firebase_config.API_KEY,
  authDomain: firebase_config.AUTH_DOMAIN,
  projectId: firebase_config.PROJECT_ID,
  storageBucket: firebase_config.STORAGE_BUCKET,
  messagingSenderId: firebase_config.MESSAGING_SENDER_ID,
  appId: firebase_config.APP_ID,
  measurementId: firebase_config.MEASUREMENT_ID,
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const firebaseAuth = getAuth(firebaseApp);

export { firebaseApp, firebaseAuth };
